/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import {
    Panel, Accordions, AccordionItem, AccordionItemHeader, AccordionItemBody,
} from 'appkit-react';

const Sidebar = ({
    setNodeName,
    uploadFile,
    isFileLoading,
    isFunctionLoading,
    reconFunctions,
    isSubProjectLoading,
    subProjects,
}) => {
    /* map files data with node type as input */
    const uploadFilesData = uploadFile ? uploadFile.map(f => ({
        ...f,
        node: 'input',
    })) : [];
    /* map recon functions with node type as default */
    const reconTypeData = reconFunctions ? reconFunctions.map(rf => ({
        ...rf,
        node: 'default',
        displayName: rf.functionName.charAt(0).toUpperCase() + rf.functionName.slice(1),
    })) : [];
    /* map sub projects with node type as special */
    const subProjectsData = subProjects ? subProjects.map(sp => ({
        ...sp,
        node: 'special',
    })) : [];

    const noFiles = (uploadFilesData.length === 0 && !isFileLoading);

    const noSubProjects = (subProjectsData.length === 0 && !isSubProjectLoading);

    const getSelectedNodeDetails = (node, type) => {
        if (type === 'input') {
            return uploadFilesData.filter(nodes => nodes.fileDisplayName === node)[0];
        }
        return type === 'special'
            ? subProjectsData.filter(nodes => nodes.projectName === node)[0]
            : reconTypeData.filter(nodes => nodes.displayName === node)[0];
    };

    /* callback function called when an element is dragged from Sidebar */
    const onDragStart = (event, nodeType) => {
        const node = event.target.innerHTML;
        const selectedNodeObj = getSelectedNodeDetails(node, nodeType);
        setNodeName(selectedNodeObj);
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };
    return (
        <div>
            <Panel style={{ marginTop: '1rem', paddingRight: 0 }}>
                <Accordions className="accordion-example true-comply__datarecon-dataconfiguration-accordion" kind="transparent" activeItem={['panel-1']}>
                    <AccordionItem itemId="panel-1">
                        <AccordionItemHeader title="UPLOADED FILES" />
                        <AccordionItemBody style={{ maxHeight: '220px', overflowY: 'auto' }}>
                            {isFileLoading && <div><span className="appkiticon icon-spinner-outline a-font-16 a-text-orange">Loading...</span></div>}
                            {
                                uploadFilesData.map(
                                    ({ fileName, node, fileDisplayName }, index) => (
                                        <div
                                            className="dndnode input"
                                            onDragStart={event => onDragStart(event, node)}
                                            draggable
                                            key={`${fileName}_${index}`}
                                        >
                                            {fileDisplayName}
                                        </div>
                                    ),
                                )
                            }
                            {/* <button type="button" onClick={handleClick}>Load More</button> */}
                            {noFiles && <div><span>No Files Uploaded!</span></div>}
                        </AccordionItemBody>
                    </AccordionItem>
                </Accordions>
            </Panel>
            <Panel style={{ marginTop: '1rem', paddingRight: 0 }}>
                <Accordions className="accordion-example true-comply__datarecon-dataconfiguration-accordion" kind="transparent" activeItem={['panel-2']}>
                    <AccordionItem itemId="panel-2">
                        <AccordionItemHeader title="RECONCILIATION TYPE" />
                        <AccordionItemBody style={{ maxHeight: '220px', overflowY: 'auto' }}>
                            {isFunctionLoading && <div><span className="appkiticon icon-spinner-outline a-font-16 a-text-orange">Loading...</span></div>}
                            {
                                reconTypeData.map(({
                                    functionId, displayName, node,
                                }) => <div className="dndnode input" onDragStart={event => onDragStart(event, node)} draggable key={functionId}>{displayName}</div>)
                            }
                        </AccordionItemBody>
                    </AccordionItem>
                </Accordions>
            </Panel>
            <Panel style={{ marginTop: '1rem', paddingRight: 0 }}>
                <Accordions className="accordion-example true-comply__datarecon-dataconfiguration-accordion" kind="transparent" activeItem={['panel-3']}>
                    <AccordionItem itemId="panel-3">
                        <AccordionItemHeader title="SUB PROJECTS CONFIGURATIONS" />
                        <AccordionItemBody style={{ maxHeight: '220px', overflowY: 'auto' }}>
                            {isSubProjectLoading && <div><span className="appkiticon icon-spinner-outline a-font-16 a-text-orange">Loading...</span></div>}
                            {
                                subProjectsData.map(
                                    ({ projectId, projectName, node }) => (
                                        <div
                                            className="dndnode input"
                                            onDragStart={event => onDragStart(event, node)}
                                            draggable
                                            key={projectId}
                                        >
                                            {projectName}
                                        </div>
                                    ),
                                )
                            }
                            {noSubProjects && <div><span>No Subprojects Available!</span></div>}
                        </AccordionItemBody>
                    </AccordionItem>
                </Accordions>
            </Panel>
        </div>
    );
};

export default Sidebar;
